module.exports = __webpack_public_path__ + "img/gjbg.a5a3fb3e.png";